import { render, staticRenderFns } from "./NavOverlayLargeLayout.vue?vue&type=template&id=2835e8cc&scoped=true&"
import script from "./NavOverlayLargeLayout.vue?vue&type=script&lang=js&"
export * from "./NavOverlayLargeLayout.vue?vue&type=script&lang=js&"
import style0 from "./NavOverlayLargeLayout.vue?vue&type=style&index=0&id=2835e8cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835e8cc",
  null
  
)

export default component.exports